import recommendationsTypes from "./recommendationsTypes";

const INITIAL_STATE = {
  items: [],
  cursor: null,
  loading: false,
  error: null,
  viewedLookup: {},
  hasMore: true,
};

const uniqByRecId = (existing, incoming) => {
  const seen = new Set(existing.map((item) => item.recId));
  return existing.concat(incoming.filter((item) => !seen.has(item.recId)));
};

const recommendationsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case recommendationsTypes.FETCH_START:
      return {
        ...state,
        loading: true,
        error: null,
        ...(action.payload?.append ? {} : { items: [] }),
      };
    case recommendationsTypes.FETCH_SUCCESS: {
      const nextItems = action.payload.append
        ? uniqByRecId(state.items, action.payload.items || [])
        : action.payload.items || [];
      return {
        ...state,
        loading: false,
        items: nextItems,
        cursor: action.payload.cursor || null,
        hasMore: Boolean(action.payload.cursor),
      };
    }
    case recommendationsTypes.FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case recommendationsTypes.DISMISS:
      return {
        ...state,
        items: state.items.filter((item) => item.recId !== action.payload),
      };
    case recommendationsTypes.MARK_VIEWED:
      if (state.viewedLookup[action.payload]) {
        return state;
      }
      return {
        ...state,
        viewedLookup: {
          ...state.viewedLookup,
          [action.payload]: true,
        },
      };
    default:
      return state;
  }
};

export default recommendationsReducer;
